import { SELECT_INPUT_OTHER_VALUE } from "@/src/common/business-layer/constants"

import { ProfileCompletionData } from "./ProfileCompletionWizard"
import { ProfileSetupData } from "./ProfileSetupWizard"

export const withOther = (choice: string, specified?: string) =>
  choice === SELECT_INPUT_OTHER_VALUE && specified
    ? `${SELECT_INPUT_OTHER_VALUE} - ${specified}`
    : choice

const OTHER_PREFIX = `${SELECT_INPUT_OTHER_VALUE} - `

export const splitOtherValue = (value?: string | null) => {
  if (!value) return { choice: "", specified: "" }

  return value.startsWith(OTHER_PREFIX)
    ? {
        choice: SELECT_INPUT_OTHER_VALUE,
        specified: value.slice(OTHER_PREFIX.length)
      }
    : { choice: value, specified: "" }
}

export const buildProfileCompletionPayload = (data: ProfileCompletionData) => ({
  team: withOther(data.team, data.teamOther),
  useCases: data.useCases.map((useCase) =>
    withOther(useCase, data.useCaseOther)
  )
})

export type ProfilePayload = {
  jobTitle: string
  team: string
  phoneNumber: string
  city: string
  country: string
  companyName?: string
  industry?: string
  companySize?: string
  referralSource?: string
  useCases: string[]
  dataPlatforms: string[]
}

export const buildProfilePayload = (
  data: ProfileSetupData,
  includeOrganisation: boolean
): ProfilePayload => ({
  jobTitle: withOther(data.role, data.roleOther),
  team: withOther(data.team, data.teamOther),
  phoneNumber: `${data.dialingCode}${data.phoneNumber}`,
  city: data.city,
  country: data.country,
  ...(includeOrganisation
    ? {
        companyName: data.companyName,
        industry: withOther(data.industry ?? "", data.industryOther),
        companySize: data.companySize,
        referralSource: data.referralSource
      }
    : {}),
  useCases: data.useCases.map((useCase) =>
    withOther(useCase, data.useCaseOther)
  ),
  dataPlatforms: data.platforms.map((platform) =>
    withOther(platform, data.platformOther)
  )
})
